import {createAction} from '@reduxjs/toolkit';
import {AuthActionTypes} from '../authActionTypes';
import {CurrentUserDetails} from '../../../../common/types';

export const setToken = createAction(AuthActionTypes.SET_TOKEN, (token: string) => {
  return {payload: token};
});

export const setUser = createAction(AuthActionTypes.SET_USER, (user: CurrentUserDetails | null) => {
  return {payload: user}
})

export const logout = createAction(AuthActionTypes.LOGOUT);
